import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';

export interface ReplyJSON {
  id: number | null;
  repliedAt: number | null;
  reply: string | null;
  replierDisplayName: string | null;
  avatarUrl: string | null;
  companyName: string | null;
}

const replyDefaults = {
  id: null,
  repliedAt: null,
  reply: null,
  replierDisplayName: null,
  avatarUrl: null,
  companyName: null,
};

export default class Reply extends createImmutableObjectClass<ReplyJSON>(
  replyDefaults
) {}
